
export default function SupportHero() {
  return (
    <section className="relative pt-28 pb-16 md:pt-36 md:pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bade0d941cc89a0e4b03a49c41054460.jpg"
          alt="고객지원 배경"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/30"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
        <span className="inline-block px-4 py-1.5 bg-white/20 backdrop-blur-sm text-white text-xs font-semibold rounded-full mb-5 tracking-widest">
          CUSTOMER SUPPORT
        </span>
        <h1
          className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight"
          style={{ fontFamily: 'Noto Serif KR, serif' }}
        >
          무엇을 도와드릴까요?
        </h1>
        <p className="text-white/80 text-sm md:text-lg leading-relaxed mb-8">
          자연담은 고객지원팀이 항상 함께합니다.<br className="hidden md:block" />
          궁금하신 점은 아래 FAQ를 확인하시거나 직접 문의해 주세요.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="#faq"
            className="px-6 py-3 bg-white text-emerald-700 rounded-full text-sm font-semibold hover:bg-emerald-50 transition-all cursor-pointer whitespace-nowrap shadow-md"
          >
            <span className="flex items-center gap-2">
              <i className="ri-question-answer-line"></i> 자주 묻는 질문
            </span>
          </a>
          <a
            href="#contact"
            className="px-6 py-3 bg-emerald-600 text-white rounded-full text-sm font-semibold hover:bg-emerald-700 transition-all cursor-pointer whitespace-nowrap shadow-md"
          >
            <span className="flex items-center gap-2">
              <i className="ri-mail-send-line"></i> 1:1 문의하기
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
